import { vars } from "@common/styles";
import { responsive } from "@common/styles/abstracts/utils";
import styled from "styled-components";

export const DetailsTitle = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  cursor: default;
  p {
    padding-left: 0.8rem;
    font-weight: normal;
    max-width: 20rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: ${vars.colors.grey10};
  }
`;

export const Sidebar = styled.div`
  flex-grow: 1;
  flex-basis: 34%;
  align-self: start;
  position: sticky;
  max-width: 48rem;

  position: relative;
  border-radius: 1rem;
  background-color: ${vars.colors.grey100};

  padding: 4rem 2.4rem;
  overflow-y: auto;

  height: calc(100vh - 13.2rem);

  ${responsive.tablet_portrait} {
    flex-basis: 50%;
  }

  ${responsive.phone} {
    flex-basis: 100%;
  }

  scrollbar-width: thin;
  scrollbar-color: ${vars.colors.grey90} transparent;

  margin-right: 0.8rem;
  &::-webkit-scrollbar {
    width: 0.8rem;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${vars.colors.grey90};
    border-radius: 0.8rem;
  }
`;

export const DropdownContainer = styled.div<{ $isError?: boolean }>`
  > div:first-child {
    > div:first-child {
      padding: 0.4rem 1.2rem;
      align-items: flex-start;
    }
  }
  div:last-child {
    width: auto;
  }

  width: 100%;

  svg {
    path {
      stroke: ${vars.colors.grey50};
    }
    width: 2rem;
    height: 2rem;
    margin-right: 1.2rem;
    flex-shrink: 0;
    display: inline-block;
  }

  span {
    color: ${vars.colors.grey30};

    &:hover: {
      opacity: 1;
      color: ${vars.colors.grey30};
    }
  }
`;

export const NavbarNavigation = styled.div`
  border-radius: 50%;
  border: 1px solid ${vars.colors.grey80}; /* Grey border */
  background-color: ${vars.colors.grey100};
  width: 3rem !important;
  height: 3rem !important;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: rotate(180deg);
  cursor: pointer;
`;
